<div class="layout-column full-height" appBringozIdGenerator="threepl-create-voucher-view">
  <form class="flex layout-column" appBringozIdGenerator="threepl-create-voucher-form" novalidate>

    <div class="layout-row padding-10 threepl-create-voucher-header gap-10">
      <div class="layout-column layout-align-center-center">
        <bz-button variant="tertiary" size="fit" type="button"
                   appBringozIdGenerator="threepl-create-voucher-back-button"
                   [ariaLabel]="'Back' | translate"
                   (clicked)="back.emit()">
          <bz-icon [icon]="icons.back" size="xl"></bz-icon>
        </bz-button>
      </div>

      <div class="flex-30 layout-column layout-align-center-start">
        <span class="br-head-4 margin-right-10">{{ 'Create New Voucher' | translate }}</span>
        <span class="br-head-3 font-weight-400">{{ dateHolder() | bringozFullDate: 'date' }} {{ extraData().name }}</span>
      </div>

      <div class="flex layout-row layout-align-start-center gap-10">
        <bz-form-field class="flex" [label]="'Name' | translate">
          <bz-input appBringozIdGenerator="threepl-create-voucher-name-input" size="sm"
                    [value]="extraData().name ?? ''" (valueChange)="onNameChange($event)"></bz-input>
        </bz-form-field>

        <app-threepl-supply-account-select class="flex"
                                           [type]="supplyAccountType"
                                           [selectedId]="supplyId()"
                                           [isRequired]="true"
                                           [submitted]="submitted()"
                                           (accountChange)="onChangeSupplyId($event)">
        </app-threepl-supply-account-select>

        <bz-form-field class="flex" [label]="'Pickup Station' | translate" [required]="true"
                       [error]="submitted() && !pickupStationId() ? ('This field is required' | translate) : ''">
          <bz-select appBringozIdGenerator="threepl-create-voucher-pickup-station-select"
                     [ariaLabel]="'Pickup Station' | translate"
                     [options]="stationOptions()"
                     [value]="pickupStationId()"
                     [searchable]="true"
                     [searchPlaceholder]="'Search' | translate"
                     size="sm"
                     (valueChange)="onPickupTrainStation($event)">
          </bz-select>
        </bz-form-field>

        <bz-form-field class="flex" [label]="'Pickup Station Extension' | translate">
          <bz-select appBringozIdGenerator="threepl-create-voucher-pickup-extension-select"
                     [ariaLabel]="'Pickup Station Extension' | translate"
                     [options]="pickupExtensionOptions()"
                     [value]="pickupTrainStationExtension()?.extensionId ?? null"
                     [disabled]="!pickupTrainStationExtensions().length"
                     [searchable]="true"
                     [searchPlaceholder]="'Search' | translate"
                     size="sm"
                     (valueChange)="onPickupTrainStationExtension($event)">
          </bz-select>
        </bz-form-field>

        <bz-form-field class="flex" [label]="'Destination Station' | translate" [required]="true"
                       [error]="submitted() && !destinationStationId() ? ('This field is required' | translate) : ''">
          <bz-select appBringozIdGenerator="threepl-create-voucher-destination-station-select"
                     [ariaLabel]="'Destination Station' | translate"
                     [options]="stationOptions()"
                     [value]="destinationStationId()"
                     [searchable]="true"
                     [searchPlaceholder]="'Search' | translate"
                     size="sm"
                     (valueChange)="onDestinationTrainStation($event)">
          </bz-select>
        </bz-form-field>

        <bz-form-field class="flex" [label]="'Destination Station Extension' | translate">
          <bz-select appBringozIdGenerator="threepl-create-voucher-destination-extension-select"
                     [ariaLabel]="'Destination Station Extension' | translate"
                     [options]="destinationExtensionOptions()"
                     [value]="destinationTrainStationExtension()?.extensionId ?? null"
                     [disabled]="!destinationTrainStationExtensions().length"
                     [searchable]="true"
                     [searchPlaceholder]="'Search' | translate"
                     size="sm"
                     (valueChange)="onDestinationTrainStationExtension($event)">
          </bz-select>
        </bz-form-field>

        <bz-button type="button" tone="primary" variant="outline"
                   appBringozIdGenerator="threepl-create-voucher-add-container-button"
                   (clicked)="onAddContainer()">
          <bz-icon class="margin-right-5" [icon]="icons.plus"></bz-icon>
          {{ 'Add Container' | translate }}
        </bz-button>
      </div>
    </div>

    <app-threepl-train-voucher-containers-table class="flex"
                                                [containers]="containerList()"
                                                [cars]="trainCars()"
                                                [sharedCarsMap]="sharedCarsMap()"
                                                [hazardousMaterials]="hazardousMaterials()"
                                                [unNumbers]="unNumbers()"
                                                [submitted]="submitted()"
                                                (changeContainer)="onChangeContainer($event)"
                                                (isSharedCarChange)="onIsSharedCarChange($event)"
                                                (removeContainer)="onRemoveContainer($event)">
    </app-threepl-train-voucher-containers-table>

    <bz-divider></bz-divider>

    <div class="layout-row layout-align-start-center padding-5 gap-10">
      <bz-button type="button" variant="tertiary" tone="secondary"
                 appBringozIdGenerator="threepl-create-voucher-cancel-button"
                 (clicked)="back.emit()">
        {{ 'Cancel' | translate }}
      </bz-button>
      <span class="flex"></span>
      <span class="br-body-2 margin-right-20">{{ 'Train Cars' | translate }}: {{ totalCars() || 0 }}</span>
      <span class="br-body-2">{{ 'Containers' | translate }}: {{ containerList().length }}</span>
      <bz-button type="button" tone="secondary"
                 appBringozIdGenerator="threepl-create-voucher-save-button"
                 [disabled]="!containerList().length"
                 (clicked)="onSave()">
        {{ 'Save' | translate }}
      </bz-button>
    </div>
  </form>
</div>
